(() => {
  if (customElements.get('mjr-cart-complements')) return;
  const dismissed = new Set();
  const rootPath = () => window.Shopify?.routes?.root || '/';
  let adding = false;

  // B11 · upsells a un toque (21-oct-2026). Configuración en snippets/mjr-upsell.liquid; precio = descuento automático del admin.
  const UPSELL_NO_KEY = 'mjr_upsell_no';
  const upsellShown = new Set();
  const upsellDismissed = new Set();
  try { JSON.parse(sessionStorage.getItem(UPSELL_NO_KEY) || '[]').forEach((r) => upsellDismissed.add(r)); } catch { /* sin almacenamiento */ }
  const clp = (cents) => '$' + Math.round(Number(cents) / 100).toLocaleString('es-CL');
  const publish = (name, data) => { try { window.Shopify?.analytics?.publish?.(name, data); } catch { /* sin píxel */ } };
  const upsellConfig = () => {
    const node = document.querySelector('[data-mjr-upsell-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch { return null; }
  };
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };

  // Elige la oferta: una sola tarjeta a la vez, en el orden de la configuración (tabla primero, luego blusa).
  function pickUpsell(context) {
    const config = upsellConfig();
    if (!config || !Array.isArray(config.reglas)) return null;
    const inCart = new Set(context.products.map((p) => String(p.id)));
    for (const rule of config.reglas) {
      if (upsellDismissed.has(rule.id)) continue;
      const stocked = (rule.productos || []).filter((p) => Number(p.stock) > 0 && Number(p.precio) > Number(rule.ahorro));
      if (!stocked.length) continue;
      if ((rule.productos || []).some((p) => inCart.has(String(p.producto)))) continue;
      if (context.products.some((p) => p.upsell === rule.id)) continue;
      const g = rule.gatillo || {};
      const triggers = context.products.filter((p) => {
        if (g.tipo && p.tipo === g.tipo) return true;
        if (g.tipo_faja && Array.isArray(p.tipo_faja)) return p.tipo_faja.some((t) => g.tipo_faja.includes(t));
        return false;
      });
      if (!triggers.length) continue;
      if (rule.elegir === 'color_faja') {
        const colors = triggers.map((p) => p.color).filter(Boolean);
        const same = stocked.filter((p) => colors.includes(p.color)).sort((a, b) => b.stock - a.stock)[0];
        const most = [...stocked].sort((a, b) => b.stock - a.stock)[0];
        const choice = same || most;
        return { rule, options: [choice], sameColor: Boolean(same), triggerColor: colors[0] || '' };
      }
      return { rule, options: stocked, sameColor: true, triggerColor: '' };
    }
    return null;
  }

  function buildUpsell(pick) {
    const { rule } = pick;
    let current = pick.options[0];
    const card = el('article', 'mjr-upsell');
    card.dataset.mjrUpsell = rule.id;
    const close = el('button', 'mjr-upsell__x', '×');
    close.type = 'button';
    close.dataset.mjrUpsellNo = rule.id;
    close.setAttribute('aria-label', 'Ocultar oferta');
    const title = el('p', 'mjr-upsell__t', rule.titulo);
    const row = el('div', 'mjr-upsell__row');
    const imgLink = el('a', 'mjr-upsell__img');
    imgLink.tabIndex = -1;
    imgLink.setAttribute('aria-hidden', 'true');
    const img = el('img');
    img.loading = 'lazy';
    img.alt = '';
    imgLink.append(img);
    const body = el('div', 'mjr-upsell__body');
    const name = el('a', 'mjr-upsell__n');
    const price = el('p', 'mjr-upsell__p');
    const now = el('strong');
    const before = el('s');
    price.append(now, ' ', before);
    const save = el('p', 'mjr-upsell__ah', 'Ahorras ' + clp(rule.ahorro));
    const variantNote = el('p', 'mjr-upsell__v');
    body.append(name, price, save);

    const form = el('form', 'mjr-upsell__form');
    form.dataset.mjrUpsellForm = rule.id;
    const idInput = el('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    const add = el('button', 'mjr-upsell__add');
    add.type = 'submit';
    const status = el('p', 'mjr-upsell__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.append(idInput, add, status);
    const no = el('button', 'mjr-upsell__no', 'No, gracias');
    no.type = 'button';
    no.dataset.mjrUpsellNo = rule.id;
    const legal = el('p', 'mjr-upsell__legal');

    const paint = () => {
      const offer = Number(current.precio) - Number(rule.ahorro);
      img.src = current.imagen || '';
      imgLink.href = current.url;
      name.href = current.url;
      name.textContent = rule.nombre || current.titulo;
      now.textContent = clp(offer);
      before.textContent = clp(current.precio);
      idInput.value = current.variante;
      add.textContent = `${rule.boton} ${clp(offer)}`;
      add.dataset.label = add.textContent;
      form.dataset.precio = String(offer);
      form.dataset.producto = String(current.producto);
      legal.textContent = `Antes ${clp(current.precio)} · precio especial ${rule.con}. ${rule.aviso}`;
      if (rule.elegir === 'color') {
        const label = (rule.nombres_color && rule.nombres_color[current.color]) || current.color;
        variantNote.textContent = `Color: ${label}`;
      } else if (current.color) {
        variantNote.textContent = pick.sameColor ? `Color ${current.color.toLowerCase()}, igual a tu faja` : `Color ${current.color.toLowerCase()} (la de tu color está agotada)`;
      }
    };

    if (rule.elegir === 'color' && pick.options.length > 1) {
      const swatches = el('div', 'mjr-upsell__colores');
      swatches.setAttribute('role', 'radiogroup');
      swatches.setAttribute('aria-label', 'Elige el color');
      pick.options.forEach((option, index) => {
        const sw = el('button', 'mjr-upsell__sw');
        sw.type = 'button';
        sw.style.background = (rule.colores && rule.colores[option.color]) || '#cccccc';
        const label = (rule.nombres_color && rule.nombres_color[option.color]) || option.color;
        sw.setAttribute('aria-label', label);
        sw.setAttribute('role', 'radio');
        sw.setAttribute('aria-checked', String(index === 0));
        sw.addEventListener('click', () => {
          current = option;
          swatches.querySelectorAll('.mjr-upsell__sw').forEach((b) => b.setAttribute('aria-checked', String(b === sw)));
          paint();
        });
        swatches.append(sw);
      });
      body.append(swatches);
    }
    body.append(variantNote);
    row.append(imgLink, body);
    card.append(close, title, row, form, no, legal);
    paint();
    return card;
  }

  class CartComplements extends HTMLElement {
    connectedCallback() {
      this.render();
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => {
        const context = this.querySelector('[data-mjr-cart-context]')?.textContent || '';
        if (context !== this.lastContext || !this.querySelector('[data-mjr-complement-content]')) this.render();
      });
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('select[name="id"]')) return;
        const option = event.target.selectedOptions[0];
        const card = event.target.closest('.mjr-complement-card');
        if (!card) return;
        card.querySelector('[data-mjr-complement-price]').textContent = option.dataset.price || '';
        const img = card.querySelector('img');
        if (img && option.dataset.image) {
          img.removeAttribute('srcset');
          img.src = option.dataset.image;
        }
      });
      this.addEventListener('click', (event) => {
        const upsellNo = event.target.closest('[data-mjr-upsell-no]');
        if (upsellNo) {
          event.preventDefault();
          event.stopPropagation();
          const id = upsellNo.dataset.mjrUpsellNo;
          upsellDismissed.add(id);
          try { sessionStorage.setItem(UPSELL_NO_KEY, JSON.stringify([...upsellDismissed])); } catch { /* sin almacenamiento */ }
          publish('mujeron_upsell_descartado', { regla: id });
          this.render();
          return;
        }
        const button = event.target.closest('[data-mjr-complement-dismiss]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        dismissed.add(button.closest('[data-product]').dataset.product);
        this.render();
        this.querySelector('button, a')?.focus();
      });
      this.addEventListener('submit', (event) => this.add(event));
    }

    disconnectedCallback() { this.observer?.disconnect(); }

    render() {
      let context;
      try {
        this.lastContext = this.querySelector('[data-mjr-cart-context]').textContent;
        context = JSON.parse(this.lastContext);
      }
      catch { this.hidden = true; return; }
      const config = document.querySelector('[data-mjr-complements-config]');
      let pick = null;
      try { pick = pickUpsell(context); } catch { pick = null; }
      if (!pick && (!config || config.dataset.enabled !== 'true')) {
        this.querySelector('[data-mjr-complement-content]')?.remove();
        this.hidden = true;
        return;
      }
      let rules = [];
      if (!pick) {
        const ids = new Set(context.products.map((p) => String(p.id)));
        const collections = new Set(context.products.flatMap((p) => p.collections.map(String)));
        const seen = new Set();
        rules = [...config.querySelectorAll('template[data-mjr-complement-rule]')].filter((rule) => {
          const target = rule.dataset.product;
          const matches = (rule.dataset.source && ids.has(rule.dataset.source)) || (rule.dataset.collection && collections.has(rule.dataset.collection));
          if (!matches || ids.has(target) || seen.has(target) || dismissed.has(target)) return false;
          seen.add(target);
          return true;
        }).slice(0, Number(config.dataset.limit) || 2);
      }
      this.querySelector('[data-mjr-complement-content]')?.remove();
      this.hidden = !pick && rules.length === 0;
      if (this.hidden) return;
      const content = document.createElement('div');
      content.dataset.mjrComplementContent = '';
      const heading = document.createElement('div');
      heading.className = 'mjr-complements-heading';
      const title = document.createElement('h3');
      title.textContent = config?.dataset.title || 'Completa tu look';
      heading.append(title);
      if (pick) {
        content.append(heading, buildUpsell(pick));
        this.append(content);
        if (!upsellShown.has(pick.rule.id)) {
          upsellShown.add(pick.rule.id);
          publish('mujeron_upsell_mostrado', { regla: pick.rule.id, producto: String(pick.options[0].producto), precio: (Number(pick.options[0].precio) - Number(pick.rule.ahorro)) / 100, mismo_color: pick.sameColor });
        }
        return;
      }
      const caption = document.createElement('p');
      caption.className = 'mjr-complements-caption';
      caption.textContent = config.dataset.caption || '';
      const grid = document.createElement('div');
      grid.className = 'mjr-complements-grid';
      rules.forEach((rule) => grid.append(rule.content.cloneNode(true)));
      content.append(heading, caption, grid);
      this.append(content);
    }

    async add(event) {
      const form = event.target.closest('[data-mjr-complement-form], [data-mjr-upsell-form]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      if (adding || !form.reportValidity()) return;
      const upsell = form.dataset.mjrUpsellForm || '';
      const button = form.querySelector('[type="submit"]');
      const status = form.querySelector('[role="status"]');
      const id = form.elements.id.value;
      const idleLabel = upsell ? (button.dataset.label || button.textContent) : '+ Añadir';
      adding = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Añadiendo…';
      status.textContent = '';
      let added = false;
      try {
        const item = { id, quantity: 1 };
        if (upsell) item.properties = { _upsell: upsell };
        const response = await fetch(`${rootPath()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item], sections: ['cart-drawer-section'], sections_url: rootPath() }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'No se pudo añadir. Revisa la disponibilidad.');
        added = true;
        if (upsell) publish('mujeron_upsell_agregado', { regla: upsell, producto: form.dataset.producto || '', variante: String(id), precio: (Number(form.dataset.precio) || 0) / 100 });
        const html = result.sections?.['cart-drawer-section'];
        const parsed = new DOMParser().parseFromString(html || '', 'text/html');
        const next = parsed.querySelector('#shopify-section-cart-drawer-section');
        const current = document.querySelector('#shopify-section-cart-drawer-section');
        if (!next || !current) { window.location.assign(`${rootPath()}cart`); return; }
        current.replaceWith(next);
        document.dispatchEvent(new CustomEvent('shopify:cart:lines-update'));
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (typeof drawer?.open === 'function') drawer.open();
        else { window.location.assign(`${rootPath()}cart`); return; }
        next.querySelector('.theme-drawer__close-button')?.focus();
      } catch (error) {
        status.textContent = added ? 'Producto añadido. Abre tu carrito para verlo.' : (error.message || 'No se pudo añadir. Inténtalo de nuevo.');
      } finally {
        adding = false;
        // Never offer another add after a confirmed success if rendering failed.
        button.disabled = added;
        button.removeAttribute('aria-busy');
        button.textContent = added ? 'Añadido' : idleLabel;
      }
    }
  }
  customElements.define('mjr-cart-complements', CartComplements);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('mjr-cart-complements').forEach((element) => element.render());
  });
})();
